import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#F8F9FD',
    padding: `${theme.spacing(1)} ${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(4)}`,
    borderRadius: '12px',
    maxWidth: '580px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%'
    }
  },
  submitButton: {
    width: '100%',
    minWidth: '297px',
    backgroundColor: '#635DFF',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'none',
    padding: '16px 20px',
    borderRadius: '12px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#5148E5'
    },
    '&:disabled': {
      backgroundColor: '#DEDEF1'
    }
  },
  confirmationText: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    background: theme.palette.publicTenantSecondary.light,
    borderRadius: '4px',
    '& p': {
      fontSize: '14px'
    }
  },
  confirmationTextIcon: {
    color: '#5D5BED',
    marginTop: 1
  },
  title: {
    color: '#000000'
  },
  titleDisabled: {
    color: '#707070'
  },
  textfield: {
    marginBottom: '8px',
    '& .MuiInputLabel-root': {
      lineHeight: '16px',
      color: '#000000',
      fontWeight: 600
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#000000'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      height: '51px',
      '& fieldset': {
        borderColor: '#000000'
      },
      '&:hover fieldset': {
        borderColor: '#000000'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000000'
      }
    },
    '& .MuiOutlinedInput-root.Mui-error': {
      borderRadius: '12px',
      height: '51px',
      '& fieldset': {
        borderColor: 'red'
      },
      '&:hover fieldset': {
        borderColor: 'red'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'red'
      }
    },
    '& .MuiInputLabel-root.Mui-error': {
      lineHeight: '16px',
      color: 'red'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      marginTop: '8px',
      marginBottom: '8px',
      fontSize: '16px',
      color: 'red',
      borderColor: 'red'
    },
    '& .MuiInputBase-input': {
      padding: '16px',
      fontSize: '16px',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    'input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
    },
    'input:-webkit-autofill:hover': {
      WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
    },
    'input:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
    },
    'input:-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 50px #F8F9FD inset !important'
    },
    '& .MuiFormHelperText-root': {
      fontSize: '0.75rem !important',
      fontWeight: 500
    }
  }
}))

export default useStyles
